module.exports = __webpack_public_path__ + "img/GTC-S-front.2cec62f1.jpg";